import {Flex, HStack, Link as ChakraLink, Spacer, Image} from '@chakra-ui/react';
import React from 'react';
import {Link} from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <Flex
            as="nav"
            position="fixed"
            bottom="0"
            left="0"
            width="100vw"
            zIndex="10"
            bg="white"
            opacity="0.85"
            maxHeight="30px"
            color="brand.500"
            borderBottomWidth="1px"
            borderBottomColor="grey.200"
            px="8"
            py="5"
            alignItems="center"
        >
            <HStack
                spacing='55'
            >
                <ChakraLink href="https://zhr.pl/">
                    <Image
                        src="logo512.png"
                        alt="Logo"
                        boxSize="30px"
                    />
                </ChakraLink>
                <ChakraLink href="https://spis.zhr.pl/"
                            color="brand.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "brand.700"
                            }}
                            height="100%"
                >
                    Strona główna spisu
                </ChakraLink>
                <ChakraLink href="https://spis-instruktorski.zhr.pl/"
                            color="brand.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "brand.700"
                            }}
                            height="100%"
                >
                    Strona rejestracji
                </ChakraLink>
            </HStack>
            <Spacer />
            <HStack
                spacing='55'
            >
                <ChakraLink as={Link} to="/info"
                            color="blue.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "blue.700"
                            }}
                            height="100%"
                >
                    Przydatne informacje
                </ChakraLink>
                <ChakraLink as={Link} to="/authors"
                            color="brand.500"
                            fontWeight="bold"
                            _hover={{
                                textDecoration: "none",
                                color: "brand.700"
                            }}
                            height="100%"
                >
                    Zespół
                </ChakraLink>
            </HStack>
        </Flex>
    );
};

export default Footer;